export default __webpack_public_path__ + "static/unitedkingdom-12337ad1495a37ccfbb93ff93eb57117.png";